/**
 *按钮
 *
 * Author:   FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/8/23      1.0     First version
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React from "react";
import PropTypes from "prop-types";
import "./index.less"

export default class TypeBreakage extends React.Component{
    static propTypes = {
        list:PropTypes.array,
    }
    static defaultProps = {
        list: [], // list
        valueKey:"code",//值对应的字段
        initValue:"",
        canClear:false, //是否可以清空选项
        disabled:false, // 是否可点击
    }
    constructor(props) {
        super(props);
        this.state = {
            value: props.initValue|| "",// 值
        }
    }
    // 赋值
    setValue(value){
        const {canClear, disabled} = this.props;
        if(disabled){//如果禁用状态
            return
        }
        if(canClear&&this.state.value==value){
            this.setState({
                value:''
            })
        }else{
            this.setState({
                value:value
            })
        }
        if(this.props.onChange){this.props.onChange(value)}
        if(this.props.callBack){this.props.callBack(value)}
    }
    componentWillMount() {
    }
    componentDidMount(){
    }

    render(){
        const { list,valueKey,disabled} = this.props;
        const { value,} = this.state;
        return (list.length>0?<div className={"typeSelectWrap"}>
                {list.map(item=><span className={`btnSelect${disabled?"":" cursor-p"}${item[valueKey]==value?" btnSelectOn":""}`} key={"bnS_"+item[valueKey]} onClick={()=>this.setValue(item[valueKey])}>
                            {item.name}
                        </span>)}
            </div>:null)
    }
}
